import EdModalConfirmation from './components/ed-modal-confirmation/ed-modal-confirmation.vue';
import EdModalContainer from './components/ed-modal-container/ed-modal-container.vue';
import EdModalMessage from './components/ed-modal-message/ed-modal-message.vue';
import EdModalGrade from './components/ed-modal-grade/ed-modal-grade.vue';
import EdBootstrapModal from './components/ed-bootstrap-modal/ed-bootstrap-modal.vue';

const ED_MODAL_EVENTS = {
  ED_CREATE_MODAL: 'ED_CREATE_MODAL',
  ED_CREATE_GRADE_MODAL: 'ED_CREATE_GRADE_MODAL',
  ED_MODAL_SHOW: 'ED_MODAL_SHOW',
  ED_MODAL_HIDE: 'ED_MODAL_HIDE',
  ED_MODAL_CONFIRMATION_HIDE: 'ED_MODAL_CONFIRMATION_HIDE',
  ED_MODAL_MESSAGE_HIDE: 'ED_MODAL_MESSAGE_HIDE',
  ED_MODAL_CHANGE_BODY: 'ED_MODAL_CHANGE_BODY',
  ED_CREATE_BOOTSTRAP_MODAL: 'ED_CREATE_BOOTSTRAP_MODAL',
  ED_BOOTSTRAP_MODAL_HIDE: 'ED_BOOTSTRAP_MODAL_HIDE'
}

const EdModal  = {
  install: (Vue) => {
    /* Components to install */
    Vue.component('ed-modal-grade', EdModalGrade);
    Vue.component('ed-modal-confirmation', EdModalConfirmation);
    Vue.component('ed-modal-container', EdModalContainer);
    Vue.component('ed-modal-message', EdModalMessage);
    Vue.component('ed-bootstrap-modal', EdBootstrapModal);
    /* Plugin */
    Vue.prototype.$EdModal = new Vue({
      methods: {
        createModal(modal, params, moreParams) {
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_CREATE_MODAL, { modal, params, moreParams });
        },
        closeModal() {
          document.getElementsByTagName('body')[0].style.overflow = 'auto';
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_HIDE);
        },
        createConfirmationModal(params) {
          this.$EdModal.$emit(
            ED_MODAL_EVENTS.ED_CREATE_MODAL, 
            {
              params: null, 
              modal: null,
              confirmation: EdModalConfirmation,
              confirmParams: params 
            }
          );
        },
        createMessageModal(params) {
          setTimeout(() => {
            this.$EdModal.$emit(ED_MODAL_EVENTS.ED_CREATE_MODAL, {modalMessage: EdModalMessage, modalMessageParams: params});
          }, 500);
        },
        refreshBody(newValue){
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_CHANGE_BODY, newValue);
        },
        createGradeModal(params) {
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_CREATE_GRADE_MODAL, params);
        },
        closeConfirmationModal() {
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_CONFIRMATION_HIDE);
        },
        createBootstrapModal(modal, params) {
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_CREATE_BOOTSTRAP_MODAL, { modal, params });
        },
        closeBootstrapModal() {
          this.$EdModal.$emit(ED_MODAL_EVENTS.ED_BOOTSTRAP_MODAL_HIDE);
        }
      }
    });
  }
}

export {
  EdModal,
  ED_MODAL_EVENTS
};